import { render, staticRenderFns } from "./expenses.vue?vue&type=template&id=6f054c04&scoped=true&"
import script from "./expenses.vue?vue&type=script&lang=js&"
export * from "./expenses.vue?vue&type=script&lang=js&"
import style0 from "./expenses.vue?vue&type=style&index=0&id=6f054c04&lang=scss&scoped=true&"
import style1 from "./expenses.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./expenses.vue?vue&type=style&index=2&id=6f054c04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f054c04",
  null
  
)

export default component.exports